// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#dropdown-menu {
    list-style-type: none;
    padding:2px 2px;
    margin:3px 2px 3px 2px;
    border:none;

}
#dropdown-menu > li{
   
    padding:2px 2px;
    margin:3px 2px 3px 2px;
    border:none;
}`, "",{"version":3,"sources":["webpack://./src/app/dropdown-basic/dropdown-basic.component.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,WAAW;;AAEf;AACA;;IAEI,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf","sourcesContent":["\n#dropdown-menu {\n    list-style-type: none;\n    padding:2px 2px;\n    margin:3px 2px 3px 2px;\n    border:none;\n\n}\n#dropdown-menu > li{\n   \n    padding:2px 2px;\n    margin:3px 2px 3px 2px;\n    border:none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
